import { NumberInput, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

const PERCENT = { style: "unit", unit: "percent" } as const;

/** The amounts, in the invoice's currency. */
export function IncomingInvoiceFormAmounts() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<p className="label">{t("incoming_invoices.amounts")}</p>
			<div className="grid grid-cols-2 gap-4">
				<NumberInput
					control={methods.control}
					name="netAmount"
					label={t("incoming_invoices.net_amount")}
					variant="decimal"
					hideButtons
					isRequired={false}
				/>
				<TextInput
					control={methods.control}
					name="currency"
					label={t("incoming_invoices.currency")}
					isRequired
				/>
				<NumberInput
					control={methods.control}
					name="vatRate"
					label={t("incoming_invoices.vat_rate")}
					variant="decimal"
					formatOptions={PERCENT}
					hideButtons
					isRequired={false}
				/>
				<NumberInput
					control={methods.control}
					name="vatAmount"
					label={t("incoming_invoices.vat_amount")}
					variant="decimal"
					hideButtons
					isRequired={false}
				/>
				<NumberInput
					control={methods.control}
					name="grossAmount"
					label={t("incoming_invoices.gross_amount")}
					variant="decimal"
					hideButtons
					isRequired={false}
				/>
			</div>
		</div>
	);
}
